// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__Iees6","layout-body":"style_layout-body__fWBzQ"};